import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  ButtonGroup,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Label,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import ExportJsonExcel from "js-export-excel";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";

function ListadoInventariosTelasHistorico() {
  const { user } = useContext(AuthContext);
  const URL_SNAPSHOT = process.env.REACT_APP_URL_INVENTARIOS_TELAS_SNAPSHOT;
  const URL_SNAPSHOT_FECHAS =
    process.env.REACT_APP_URL_INVENTARIOS_TELAS_SNAPSHOT_FECHAS;
  const URL_SNAPSHOT_DETALLE =
    process.env.REACT_APP_URL_INVENTARIOS_TELAS_SNAPSHOT_DETALLE;

  const [fechas, setFechas] = useState([]);
  const [selectedFecha, setSelectedFecha] = useState("");
  const [comments, setComments] = useState([]);

  // Modal de detalle por rollo
  const [modalDetalle, setModalDetalle] = useState(false);
  const toggleDetalle = () => setModalDetalle(!modalDetalle);
  const [detalle, setDetalle] = useState([]);
  const [nombreDetalle, setNombreDetalle] = useState("");

  //--- Pagination
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const ITEMS_PER_PAGE = 50;

  // Cargamos las fechas disponibles y preseleccionamos la mas reciente
  useEffect(() => {
    axios
      .get(URL_SNAPSHOT_FECHAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFechas = response.data;
        setFechas(allFechas);
        if (allFechas.length > 0 && selectedFecha === "") {
          setSelectedFecha(allFechas[0]);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Cargamos el inventario de la fecha seleccionada
  useEffect(() => {
    if (selectedFecha === "") {
      setComments([]);
      return;
    }
    showLoader();
    axios
      .get(`${URL_SNAPSHOT}/${selectedFecha}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSnapshot = response.data;
        let arrayTabla = allSnapshot
          .map((a) => {
            const unidad = a.unidad || "";
            const cantidad = a.cantidad;
            const rendimiento = a.telas[0] ? a.telas[0].rendimiento : 0;
            // Total Metros: metros directos + kilos convertidos con el rendimiento
            let metros2;
            if (unidad === "Metros") {
              metros2 = cantidad;
            } else if (unidad === "Kilos") {
              metros2 = cantidad * rendimiento;
            } else {
              metros2 = 0;
            }
            return {
              _id: a._id,
              idTela: a.telas[0] ? a.telas[0]._id : "",
              codigo: a.telas[0] ? a.telas[0].codigo : "",
              tela: a.telas[0] ? a.telas[0].nombre : "",
              idColor: a.colores[0] ? a.colores[0]._id : "",
              color: a.colores[0] ? a.colores[0].name : "",
              unidad: unidad,
              cantidad: cantidad,
              rendimiento: rendimiento,
              metros2: metros2,
              costo: a.costo || 0,
              costoTotal: a.costoTotal || 0,
              rollos: a.rollos,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);
        hideLoader();
      })
      .catch((err) => {
        console.log(err);
        hideLoader();
      });
  }, [selectedFecha]);

  function verDetalle(idTela, idColor, tela, color) {
    setNombreDetalle(`${tela} / ${color} al ${selectedFecha}`);
    axios
      .get(`${URL_SNAPSHOT_DETALLE}/${selectedFecha}/${idTela}/${idColor}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setDetalle(response.data);
        toggleDetalle();
      })
      .catch((err) => {
        console.log(err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cargar el detalle!",
        });
      });
  }

  function PDFTabla() {
    // Filas filtradas (todo, no solo la pagina)
    const filas = comments.filter(
      (a) =>
        !search ||
        a.tela.toLowerCase().includes(search.toLowerCase()) ||
        a.color.toLowerCase().includes(search.toLowerCase()) ||
        a.codigo.toLowerCase().includes(search.toLowerCase())
    );

    const data = filas.map((a) => [
      a.codigo,
      a.tela,
      a.color,
      a.unidad,
      new Intl.NumberFormat("en-US").format(a.cantidad),
      new Intl.NumberFormat("en-US").format(a.metros2),
      a.rollos,
      "$" + new Intl.NumberFormat("en-US").format(a.costo.toFixed(2)),
      "$" + new Intl.NumberFormat("en-US").format(a.costoTotal.toFixed(2)),
    ]);

    const doc = new jsPDF("landscape");
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 15, 60, 25);
    doc.text(`Inventario de Telas al ${selectedFecha}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Tela",
          "Color",
          "Unidad",
          "Cantidad",
          "Total Metros",
          "Rollos",
          "Costo",
          "Costo Total",
        ],
      ],
      body: data,
      startY: 50,
      foot: [
        [
          "",
          "",
          "",
          "Total",
          "M: " + new Intl.NumberFormat("en-US").format(totalMetros),
          new Intl.NumberFormat("en-US").format(totalMetros2),
          new Intl.NumberFormat("en-US").format(totalRollos),
          "",
          "$" + new Intl.NumberFormat("en-US").format(totalCosto.toFixed(2)),
        ],
      ],
      showFoot: "lastPage",
    });
    doc.save(`InventarioTelas-${selectedFecha}.pdf`);
  }

  function excel() {
    // Exporta todo lo filtrado (no solo la pagina actual)
    const dataExcel = comments
      .filter(
        (a) =>
          !search ||
          a.tela.toLowerCase().includes(search.toLowerCase()) ||
          a.color.toLowerCase().includes(search.toLowerCase()) ||
          a.codigo.toLowerCase().includes(search.toLowerCase())
      )
      .map((a) => {
        return {
          Fecha: selectedFecha,
          Codigo: a.codigo,
          Tela: a.tela,
          Color: a.color,
          Unidad: a.unidad,
          Cantidad: a.cantidad,
          TotalMetros: a.metros2,
          Rollos: a.rollos,
          Costo: a.costo,
          CostoTotal: a.costoTotal,
        };
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};
    option.fileName = `InventarioTelas-${selectedFecha}`;
    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "Inventario Telas",
        sheetFilter: [
          "Fecha",
          "Codigo",
          "Tela",
          "Color",
          "Unidad",
          "Cantidad",
          "TotalMetros",
          "Rollos",
          "Costo",
          "CostoTotal",
        ],
        sheetHeader: [
          "Fecha",
          "Codigo",
          "Tela",
          "Color",
          "Unidad",
          "Cantidad",
          "Total Metros",
          "Rollos",
          "Costo",
          "Costo Total",
        ],
      },
    ];
    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Tela", field: "tela", sortable: true },
    { name: "Color", field: "color", sortable: true },
    { name: "Unidad", field: "unidad", sortable: true },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Total Metros", field: "metros2", sortable: true },
    { name: "Rollos", field: "rollos", sortable: true },
    { name: "Costo", field: "costo", sortable: true },
    { name: "Costo Total", field: "costoTotal", sortable: true },
    { name: "Detalle", field: "detalle", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.tela.toLowerCase().includes(search.toLowerCase()) ||
          comment.color.toLowerCase().includes(search.toLowerCase()) ||
          comment.codigo.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort((a, b) => {
        if (typeof a[sorting.field] === "number") {
          return reversed * (a[sorting.field] - b[sorting.field]);
        }
        return (
          reversed *
          String(a[sorting.field]).localeCompare(String(b[sorting.field]))
        );
      });
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting]);

  // Totales de todo lo filtrado (no solo la pagina actual),
  // separados por unidad como en ListadoInventarios
  let totalMetros = 0;
  let totalKilos = 0;
  let totalMetros2 = 0;
  let totalRollos = 0;
  let totalCosto = 0;
  comments
    .filter(
      (comment) =>
        !search ||
        comment.tela.toLowerCase().includes(search.toLowerCase()) ||
        comment.color.toLowerCase().includes(search.toLowerCase()) ||
        comment.codigo.toLowerCase().includes(search.toLowerCase())
    )
    .forEach((a) => {
      if (a.unidad === "Metros") {
        totalMetros = totalMetros + a.cantidad;
      } else if (a.unidad === "Kilos") {
        totalKilos = totalKilos + a.cantidad;
      }
      totalMetros2 = totalMetros2 + a.metros2;
      totalRollos = totalRollos + a.rollos;
      totalCosto = totalCosto + a.costoTotal;
    });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card container col-11">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuCatalogos"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                  disabled={comments.length === 0}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                  disabled={comments.length === 0}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <h3 align="center">Inventario de Telas por Fecha</h3>

          <Row>
            <Col md={4}>
              <Label className="mr-sm-2">Fecha</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFecha}
                onChange={(e) => {
                  setSelectedFecha(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </Col>
          </Row>
          <br />
          {comments.length > 0 ? (
            <Row className="text-center">
              <Col>
                <TotalCard
                  titulo="Rollos"
                  valor={new Intl.NumberFormat("en-US").format(totalRollos)}
                  color="#0d6efd"
                />
              </Col>
              <Col>
                <TotalCard
                  titulo="Metros"
                  valor={new Intl.NumberFormat("en-US").format(totalMetros)}
                  color="#20c997"
                />
              </Col>
              <Col>
                <TotalCard
                  titulo="Kilos"
                  valor={new Intl.NumberFormat("en-US").format(totalKilos)}
                  color="#6f42c1"
                />
              </Col>
              <Col>
                <TotalCard
                  titulo="Total Metros"
                  valor={new Intl.NumberFormat("en-US").format(totalMetros2)}
                  color="#0dcaf0"
                />
              </Col>
              <Col>
                <TotalCard
                  titulo="Costo Total"
                  valor={
                    "$" +
                    new Intl.NumberFormat("en-US").format(
                      totalCosto.toFixed(2)
                    )
                  }
                  color="#198754"
                />
              </Col>
            </Row>
          ) : undefined}

          {selectedFecha !== "" && comments.length === 0 ? (
            <>
              <br />
              <h5 align="center">
                No hay foto de inventario para el {selectedFecha}. Se genera una
                automaticamente cada dia a partir de hoy.
              </h5>
            </>
          ) : undefined}

          <br />
          <div className="row">
            <div className="col-md-6">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-6 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                return (
                  <tr key={a._id}>
                    <td>{a.codigo}</td>
                    <td>{a.tela}</td>
                    <td>{a.color}</td>
                    <td>{a.unidad}</td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.cantidad)}
                    </td>
                    <td>
                      {new Intl.NumberFormat("en-US").format(a.metros2)}
                    </td>
                    <td>{a.rollos}</td>
                    <td>
                      {"$" +
                        new Intl.NumberFormat("en-US").format(
                          a.costo.toFixed(2)
                        )}
                    </td>
                    <td>
                      {"$" +
                        new Intl.NumberFormat("en-US").format(
                          a.costoTotal.toFixed(2)
                        )}
                    </td>
                    <td>
                      <Button
                        size="sm"
                        className="btn"
                        color="info"
                        onClick={(e) =>
                          verDetalle(a.idTela, a.idColor, a.tela, a.color)
                        }
                      >
                        <i class="fas fa-search"></i>
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>

          <Modal size="lg" isOpen={modalDetalle} toggle={toggleDetalle}>
            <ModalHeader toggle={toggleDetalle}>
              <h4>Rollos de {nombreDetalle}</h4>
            </ModalHeader>
            <ModalBody>
              <Table size="sm" striped borderless>
                <thead>
                  <tr>
                    <th>Rollo</th>
                    <th>Cantidad</th>
                    <th>Unidad</th>
                    <th>Apartado</th>
                  </tr>
                </thead>
                <tbody>
                  {detalle.map((a) => {
                    return (
                      <tr key={a._id}>
                        <td>
                          {a.inventariosTelas[0]
                            ? a.inventariosTelas[0]._id
                            : ""}
                        </td>
                        <td>
                          {new Intl.NumberFormat("en-US").format(a.cantidad)}
                        </td>
                        <td>{a.unidad}</td>
                        <td>{a.apartado}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
      {loader}
    </>
  );
}

// Tarjeta de total con franja de color, titulo y valor
function TotalCard({ titulo, valor, color }) {
  return (
    <div
      style={{
        border: "1px solid #e3e6ea",
        borderTop: `4px solid ${color}`,
        borderRadius: "8px",
        padding: "10px 8px",
        background: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          fontSize: "0.72rem",
          textTransform: "uppercase",
          letterSpacing: "0.5px",
          color: "#6c757d",
          marginBottom: "2px",
        }}
      >
        {titulo}
      </div>
      <div style={{ fontSize: "1.25rem", fontWeight: 700, color: "#212529" }}>
        {valor}
      </div>
    </div>
  );
}

export default ListadoInventariosTelasHistorico;
